var map = {
	"./client1.png": 4693,
	"./client2.png": 5918,
	"./client3.png": 5911,
	"./client4.png": 6296,
	"./client5.png": 9009,
	"./client6.png": 26,
	"./client7.png": 787,
	"./client8.png": 5492,
	"./logo_Footer.png": 7554,
	"./proj1.jpg": 1649,
	"./proj10.jpg": 1085,
	"./proj11.jpg": 9952,
	"./proj12.jpg": 3567,
	"./proj13.jpg": 1186,
	"./proj14.jpg": 6673,
	"./proj15.jpg": 8628,
	"./proj16.jpg": 2787,
	"./proj2.jpg": 4950,
	"./proj3.jpg": 1411,
	"./proj4.jpg": 4928,
	"./proj5.jpg": 6061,
	"./proj6.jpg": 6162,
	"./proj7.jpg": 8543,
	"./proj8.jpg": 6828,
	"./proj9.jpg": 4873,
	"./whatsapp-qrcode.png": 2226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;